import { tap } from "rxjs/operators";
import { AccountService } from "src/app/services/account.service";
import { Injectable } from "@angular/core";
import * as Bowser from "bowser";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { UrlConstants } from "../models/urlConstants";
const browser = Bowser.getParser(window.navigator.userAgent);
@Injectable()
export class RequestHeaderInterceptor implements HttpInterceptor {
  browserName: any;
  constructor(private accService: AccountService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.browserName = browser.getBrowserName();

    const idToken = JSON.parse(sessionStorage.getItem("user"));
    let modifiedRequest;
    let key = "";

    if (
      UrlConstants != null &&
      UrlConstants.appKey != null &&
      UrlConstants.appKey != undefined
    )
      key = UrlConstants.appKey;
    modifiedRequest = request.clone({
      headers: request.headers
        .set("device_type", this.browserName)
        .set("app_Key", key)
        .set("Content-Type", "application/json"),
    });
    if (idToken) {
      modifiedRequest = modifiedRequest.clone({
        headers: modifiedRequest.headers.set("Authorization", idToken),
      });
    }
    return next.handle(modifiedRequest).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (
              err.status === 401 &&
              err.url != UrlConstants.backofficeUrl + "/api/Token/CheckAuthentication"
            ) {
              // refresh token or navigate to login
              this.accService.logout();
            } else if (err.status === 404) {
              //not found
            } else if (err.status === 400) {
              // bad request
            } else {
              // global request
            }
          }
        }
      )
    );
  }
}
